import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  activeSparxSelectionResolved,
  sparxsEditorPanelTabSelected,
} from "@/features/sparxsEditor/store/domainActions";

const SelectedInputFieldSlice = createSlice({
  name: "selectedInputField",
  initialState: "",
  reducers: {
    updateSelectedInputField: (_, action: PayloadAction<string>) =>
      action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(activeSparxSelectionResolved, (state, action) =>
      action.payload.clearSelectedInputField ? "" : state,
    );
    builder.addCase(sparxsEditorPanelTabSelected, () => "");
  },
});

export const { updateSelectedInputField } = SelectedInputFieldSlice.actions;
export default SelectedInputFieldSlice.reducer;
